import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'formatEstado'
})
export class FormatEstadoPipe implements PipeTransform {
  transform(estado: string): string {
    if (!estado) return '';
    
    switch(estado.toLowerCase()) {
      case 'approved':
        return 'Aprobado';
      case 'creado':
        return 'Creado';
      case 'rechazado':
        return 'Rechazado';
      case 'pendiente':
        return 'Pendiente';
      case 'anulado':
        return 'Anulado';
      default:
        return estado;
    }
  }
}
